import {
  getEmailField,
  getPhoneNumberField,
  getStateProvinceField,
  getZipPostalCodeField,
} from 'portal/src/components/common/forms/commonFormFields';
import {
  autoCompleteType,
  patternInputType,
  textInputType,
} from 'portal/src/components/common/forms/FormFieldTypes';

export const getEsContactFields = (
  isRequired: boolean,
): (autoCompleteType | textInputType | patternInputType)[] => [
  {
    placeholder: 'First Name',
    label: 'First Name',
    name: 'esContactFirstName',
    type: 'textInput',
    required: isRequired,
  },
  {
    placeholder: 'Last Name',
    label: 'Last Name',
    name: 'esContactLastName',
    type: 'textInput',
    required: isRequired,
  },
  {
    placeholder: 'Address 1',
    label: 'Address 1',
    name: 'esContactAddress1',
    type: 'textInput',
    required: isRequired,
  },
  {
    placeholder: 'Address 2',
    label: 'Address 2',
    name: 'esContactAddress2',
    type: 'textInput',
    required: false,
  },
  {
    placeholder: 'City',
    label: 'City',
    name: 'esContactCity',
    type: 'textInput',
    required: isRequired,
  },
  getStateProvinceField(null, isRequired, false),
  getZipPostalCodeField(null, isRequired, false),
  getEmailField(isRequired, false, 'esContactEmail'),
  {
    placeholder: 'Job Title',
    label: 'Job Title',
    name: 'esContactJobTitle',
    type: 'textInput',
    required: isRequired,
  },
  getPhoneNumberField(isRequired, 'esContactPhone'),
];
